import React,{useEffect,useState} from "react"
import api from "../api/api"
import { toast } from "react-toastify";


function PaymentSettings(){

const [data,setData] = useState({
 enableCOD:false,
 enableUPI:false,
 enableRazorpay:false,
 upiId:""
})

useEffect(()=>{
 loadPayment()
},[])

const loadPayment = async ()=>{
 try{
 const res = await api.get("/settings/payment")
 if(res.data) setData(res.data)
 }catch(error){
 console.error("Payment load error:",error)
 }
}

const handleChange=(e)=>{
 const {name,value,type,checked}=e.target
 setData({...data,[name]:type==="checkbox"?checked:value})
}

const handleSubmit=async(e)=>{
 e.preventDefault()

 try{
 await api.put("/settings/payment",data)
 toast.success("Payment settings updated ✅");
 
 }catch(error){
 console.error("Update error:",error)
 }
}

return(

<div className="container mt-4">

<div className="card shadow-sm">

<div className="card-header " style={{backgroundColor : "#BFC9D1"}}>
<h5 style={{lineHeight : "1.5", color : "white"}}>Payment Settings</h5>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="form-check">
<input type="checkbox" name="enableCOD" checked={data.enableCOD||false} onChange={handleChange}/>
<label className="ms-2">Cash On Delivery</label>
</div>

<div className="form-check mt-2">
<input type="checkbox" name="enableUPI" checked={data.enableUPI||false} onChange={handleChange}/>
<label className="ms-2">UPI Payment</label>
</div>

<input
name="upiId"
value={data.upiId||""}
onChange={handleChange}
placeholder="UPI ID"
className="form-control mt-3"
/>

<div className="form-check mt-3">
<input type="checkbox" name="enableRazorpay" checked={data.enableRazorpay||false} onChange={handleChange}/>
<label className="ms-2">Razorpay</label>
</div>

<button className="btn btn-primary mt-4">
Save Settings
</button>

</form>

</div>

</div>

</div>

)

}

export default PaymentSettings